module.exports = __webpack_public_path__ + "static/media/img1.6b0b32e3.png";